import React, { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { useNavigate } from "react-router-dom";
import { extractLinks } from "@/lib/helper";
import logomainsvg from "@/assets/logo-main.svg";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import useDocumentTitle from "@/components/ui/common/document-title";
import { useCreateQRTokenMutation } from "@/services/checkInApis";

const QRCodePage: React.FC = () => {
  const [qrData, setQrData] = React.useState<string>("");
  const orgId = useSelector(
    (state: RootState) => state.auth.userInfo?.user?.org_id
  );
  const navigate = useNavigate();
  const userToken = localStorage.getItem("userToken");
  // Redirect to `/` if `userToken` is missing
  useEffect(() => {
    if (!userToken) {
      navigate("/");
      return;
    }
  }, [userToken, navigate]);

  // Safely parse `sidepanel` from localStorage
  let links: string[] = [];
  try {
    const sidepanel = localStorage.getItem("sidepanel");
    const decodedSidepanel = sidepanel ? JSON.parse(atob(sidepanel)) : null;
    links = decodedSidepanel ? extractLinks(decodedSidepanel) : [];
  } catch (error) {
    console.error("Error parsing sidepanel:", error);
    links = [];
  }
  // Extract user info from localStorage
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  const userId = userInfo.user?.id;
  const userOrgId = userInfo.user?.org_id;

  const [createQRToken] = useCreateQRTokenMutation();

  useEffect(() => {
    const data = `${userId},${userOrgId},staff`;
    setQrData(data);
  }, [userId, userOrgId]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 700 && links[0]) {
        navigate(links[0]); // Add a fallback route if `sidepanel[0]` is not available
      }
    };

    // Check initially in case the width is already > 700
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [navigate, links]);

  useDocumentTitle("QR Code");

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h2 className="text-lg font-bold mb-4">Scan the QR Code</h2>
      <QRCodeSVG
        value={qrData}
        size={256}
      />
      <p className="mt-4 text-center text-gray-600">
        Use this QR code for secure access.
      </p>
      {/* <p className="mt-2 text-sm text-gray-500">{qrData}</p> */}
    </div>
  );
};

export default QRCodePage;